export const firebaseConfig = {
  apiKey: "AIzaSyC1BB2gvqTs1dgVBPteb3FuXAZAYyR84-Y",
  authDomain: "the-papers-app.firebaseapp.com",
  projectId: "the-papers-app",
  storageBucket: "the-papers-app.appspot.com",
  messagingSenderId: "670234628165",
  appId: "1:670234628165:web:3a34c5d9be8bf22dea532c",
  measurementId: "G-0BS4KEWRYY",
};
